/**
 * @flow
 * @relayHash 2ae3b3b4340173379aaf8ba1c44d7199
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedWarehouseLocationsContainer_data$ref = any;
export type PaginatedWarehouseLocationsContainerPaginationQueryVariables = {|
  count: number,
  cursor?: ?string,
  search?: ?string,
|};
export type PaginatedWarehouseLocationsContainerPaginationQueryResponse = {|
  +$fragmentRefs: PaginatedWarehouseLocationsContainer_data$ref
|};
export type PaginatedWarehouseLocationsContainerPaginationQuery = {|
  variables: PaginatedWarehouseLocationsContainerPaginationQueryVariables,
  response: PaginatedWarehouseLocationsContainerPaginationQueryResponse,
|};
*/


/*
query PaginatedWarehouseLocationsContainerPaginationQuery(
  $count: Int!
  $cursor: String
  $search: String
) {
  ...PaginatedWarehouseLocationsContainer_data_3PfUTl
}

fragment PaginatedWarehouseLocationsContainer_data_3PfUTl on Query {
  warehouseLocations(first: $count, after: $cursor, search: $search) {
    edges {
      cursor
      node {
        id
        name
        code
        description
        isActive
        updatedAt
        createdAt
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PaginatedWarehouseLocationsContainerPaginationQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "PaginatedWarehouseLocationsContainer_data",
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaginatedWarehouseLocationsContainerPaginationQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "warehouseLocations",
        "storageKey": null,
        "args": (v2/*: any*/),
        "concreteType": "WarehouseLocationConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocationEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "WarehouseLocation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "code",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "description",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isActive",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "createdAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "warehouseLocations",
        "args": (v2/*: any*/),
        "handle": "connection",
        "key": "PaginatedWarehouseLocationsContainer_warehouseLocations",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PaginatedWarehouseLocationsContainerPaginationQuery",
    "id": null,
    "text": "query PaginatedWarehouseLocationsContainerPaginationQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n) {\n  ...PaginatedWarehouseLocationsContainer_data_3PfUTl\n}\n\nfragment PaginatedWarehouseLocationsContainer_data_3PfUTl on Query {\n  warehouseLocations(first: $count, after: $cursor, search: $search) {\n    edges {\n      cursor\n      node {\n        id\n        name\n        code\n        description\n        isActive\n        updatedAt\n        createdAt\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e022ba4acc43527210bd09c3b9554252';
module.exports = node;
